export default __webpack_public_path__ + "assets/b1557651aba5b2c7a992d0f9a65f7418.svg";